import { Agreement, ChoiceFilter, MultiChoiceFilter } from '@model';
import { Choice } from './choice.model';

export class ServiceAgreementFilterSettings {
  // filterCustomersBy?: string;
  groupByCustomers?: boolean;
  filterOnExpiration?: boolean;
  filterOnStatus?: boolean;
  
  statusMultiChoiceFilter?: MultiChoiceFilter;
  expirationCheckBoxFilter?: ChoiceFilter;
}
